import { ListChecksIcon } from '@phosphor-icons/react'
import { Button } from 'app/components/ui/button'

/** A board's way into and out of bulk selection, drawn the way the tables draw theirs. */
export function BulkSelectToggle({ selecting, onToggle }: { selecting: boolean; onToggle: () => void }) {
  return (
    <Button
      variant={selecting ? `white` : `secondary`}
      size="sm"
      onClick={onToggle}
      title={selecting ? undefined : `Bulk actions`}
    >
      {selecting ? (
        `Done`
      ) : (
        <>
          <ListChecksIcon size={16} />
          <span className="max-md:hidden">Bulk actions</span>
        </>
      )}
    </Button>
  )
}
